import { render, staticRenderFns } from "./provider-notification-board.vue?vue&type=template&id=4680118c&scoped=true&"
import script from "./provider-notification-board.vue?vue&type=script&lang=ts&"
export * from "./provider-notification-board.vue?vue&type=script&lang=ts&"
import style0 from "./provider-notification-board.vue?vue&type=style&index=0&id=4680118c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4680118c",
  null
  
)

export default component.exports